import { useCallback, useState } from 'react';

/**
 * Acordeón de las tablas en modo tarjeta (patrón `.data-table--cards` de globals.css, breakpoint
 * único de 640 px). Nueve tablas operativas ya lo usaban con este mismo estado local repetido en
 * cada componente; Owner Intelligence v1 lo necesita en las cuatro tablas ANALÍTICAS (spec §17),
 * así que aquí se extrae una sola vez en vez de copiarlo tres veces más.
 *
 * En escritorio no cambia nada: la clase solo tiene efecto por debajo de 640 px.
 */
export function useCardRows() {
  const [expandedIds, setExpandedIds] = useState<ReadonlySet<string>>(() => new Set());

  const toggle = useCallback((id: string) => {
    setExpandedIds((current) => {
      const next = new Set(current);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  /** Clase de la fila: cerrada por defecto, igual que las tablas operativas ya resueltas. */
  const rowClass = useCallback(
    (id: string, extra = '') => `${extra} ${expandedIds.has(id) ? 'dt-card--open' : 'dt-card--closed'}`.trim(),
    [expandedIds],
  );

  return { toggle, rowClass };
}
